import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'

import AppImgBg from '../app-img-bg'
import AppBtn from '../app-btn'


export default
{
    name: 'page-copyright',

    mixins:
    [
        AppPage,
        CoreResize
    ],

    components:
    {
        AppImgBg,
        AppBtn
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
    },

    methods:
    {
        onResized()
        {
            this.$nextTick(() => this.$emit('load', this))
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-copyright/script.js